import { Header } from '@components/Header';
import BriefcaseIcon from '@components/icons/Briefcase.svg';
import TrainingIcon from '@components/icons/Training.svg';
import UserGuideIcon from '@components/icons/UserGuide.svg';
import { routes } from '@routes';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const learningPaths = [
  {
    title: 'Editor-Proofer',
    description:
      'Interactive tutorials for editors and proofreaders. Choose AutoScript Desktop, Word or WordPerfect, or CAT export based on how you work.',
    to: routes.trainingEditorProofer.make(),
    icon: TrainingIcon,
  },
  {
    title: 'Agency',
    description:
      'Learn how agencies manage jobs, cases, and team members, and collaborate across your organization from end to end.',
    to: routes.trainingAgency.make(),
    icon: BriefcaseIcon,
  },
] as const;

export const TrainingHubPage = () => (
  <>
    <Helmet>
      <title>Welcome to AutoScript Training - AutoScript</title>
    </Helmet>
    <Header title="Welcome to AutoScript Training" />

    <main className="px-4 md:px-[30px] pt-2 pb-[70px] max-w-[1100px]">
      <section className="mb-8 mt-8 max-w-[720px]">
        <p className="mt-0 mb-0 text-sm leading-[150%] text-[var(--color-text-muted)]">
          Select your use case to unlock your learning path. Each course is designed to take 20 minutes or less of your
          time.
        </p>
      </section>

      <div className="grid gap-4 md:grid-cols-2">
        {learningPaths.map((path) => {
          const Icon = path.icon;

          return (
            <div
              key={path.title}
              className="flex flex-col border border-[var(--color-border)] rounded-[8px] bg-[var(--color-surface)] p-5 shadow-[0_8px_24px_var(--color-shadow)]"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[var(--color-surface-muted)] text-[var(--color-fixed-brand)]">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="mt-4 text-lg font-semibold text-[var(--color-text)] m-0">{path.title}</h3>
              <p className="mt-3 mb-6 text-sm leading-[150%] text-[var(--color-text-muted)] flex-1">
                {path.description}
              </p>
              <Link to={path.to} className="btn w-full justify-center sm:w-auto sm:self-start">
                Let&apos;s Get Started
              </Link>
            </div>
          );
        })}
      </div>

      <section className="mt-4 flex flex-col gap-4 border border-[var(--color-border)] rounded-[8px] bg-[var(--color-surface-muted)] p-5 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-4">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[var(--color-surface)] text-[var(--color-fixed-brand)]">
            <UserGuideIcon className="h-5 w-5" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-[var(--color-text)] m-0">Additional Resources</h3>
            <p className="mt-2 mb-0 text-sm leading-[150%] text-[var(--color-text-muted)]">
              External courses, a full AutoScript tutorial, and self-help documentation.
            </p>
          </div>
        </div>
        <Link
          to={routes.trainingAdditionalResources.make()}
          className="btn btn--outlined w-full justify-center md:w-auto md:shrink-0"
        >
          View Resources
        </Link>
      </section>
    </main>
  </>
);
